import { getAngularJsService } from '../../../Js/React/Services/legacy';
import { EngageObjectType, EngageObjectUserStatus } from '../../types';

export const logEngageUserStatus = (
	objectId: number,
	objectType: EngageObjectType,
	status: EngageObjectUserStatus,
	passed: boolean
) => {
	const bizEngageService = getAngularJsService('bizEngageService');
	bizEngageService.LogUserStatus(objectId, objectType, status, passed);
};
